import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../components/Button/Button";
import CadastroContainer from "../../components/CadastroContainer/CadastroContainer";
import OpenDoorButton from "../../components/OpenDoorButton/OpenDoorButton";
import { useUserStore } from "../../contexts/userStore";
import AutomationButtonService from "../../services/AutomationButtonService";
import EventDetails from "../../views/Events/EventDetails/EventDetails";
import "./Reception.css";
import { useAuth } from "../../contexts/auth";
import { IoIosCloudyNight } from "react-icons/io";
import { AutomationButton } from "./AutomationButton";
import AggregatesService from "../../services/AggregatesService";
import { Ways } from "../AccessWay/Ways";
import { useSSEContext } from "../../contexts/sse";
import { ReceptionHeader } from "../../components/ReceptionHeader/ReceptionHeader";
import { AccessEventsFlowChart } from "../../components/AccessEventsFlowChart/AccessEventsFlowChart";
import AlarmMonitoring from "../AlarmMonitoring/AlarmMonitoring";
import PresenceMonitoring from "../PresenceMonitoring/PresenceMonitoring";
import AccessMonitoring from "../AccessMonitoring/AccessMonitoring";
import { RiEye2Line } from "react-icons/ri";
import { ScrollText } from "lucide-react";
import SearchCondoUser from "../../components/SearchCondoUser/SearchCondoUser";
import { NotificationManager } from "react-notifications";
import Select from "../../components/Select/Select";
import { GoArrowSwitch } from "react-icons/go";
import { wait } from "../../utils/timer";
import TitleContainer from "../../components/TitleContainer/TitleContainer";
import { TbBuildingCommunity, TbBulb, TbDoorEnter, TbDoorExit } from "react-icons/tb";
import { FastFormCondoUserModal } from "../CondoUsers/FastFormCondoUserModal/FastFormCondoUserModal";
import { FastFormCondoUserProvider } from "../CondoUsers/FastFormCondoUserModal/context";
import Loader from "../../components/Loader/Loader";
import { publish, subscribe, unsubscribe } from "../../utils/events";
import { MdOutlineMapsHomeWork } from "react-icons/md";
import { NoLicense } from "../NoLicense/NoLicense";
import { useTranslation } from "react-i18next";
import { LuLightbulb } from "react-icons/lu";

const Reception = () => {
	const { can } = useAuth();
	const { tab } = useParams();
	const [selectedTab, setSelectedTab] = useState(tab || "reception");
	const [eventsMode, setEventsMode] = useState("all");
	const [events, setEvents] = useState([]);
	const {
		selectedCondominio,
		selectedCondominioObj,
		selectedLicenceObj,
		selectingUnit,
		licences,
	} = useUserStore();
	const [automationButtonsItems, setAutomationButtonsItems] = useState([]);
	const navigate = useNavigate();
	const { sseReceived } = useSSEContext();
	const cancelTokenRef = useRef(null);
	const [isEventsLoading, setIsEventsLoading] = useState(true);
	const [isAutomationButtonsLoading, setIsAutomationButtonsLoading] = useState(true);
	const { t, i18n } = useTranslation();

	useEffect(() => {
		setSelectedTab(tab || "reception");
	}, [tab]);

	const getEvents = async (page, condominiumId) => {
		if (condominiumId === 0) return;
		setIsEventsLoading(true);
		try {
			if (cancelTokenRef.current) {
				cancelTokenRef.current.abort();
			}
			cancelTokenRef.current = new AbortController();
			const filters = {
				name: "",
				eventType: "Acesso,Alarme",
				startDate: "",
				endDate: "",
				licence: "",
				detail: "Lado",
				data: "",
				user: "",
				uuid: "",
				result: "",
				info: "",
				carName: "",
				carBrand: "",
				carColor: "",
				carPlate: "",
				listMode: eventsMode,
				targetNotEmpty: true,
			};
			const collumnClicked = { collumnTitle: "id", orderDirection: "DESC" };
			const response = await AggregatesService.listEventsWithUsers(
				condominiumId,
				page,
				filters,
				collumnClicked,
				30,
				cancelTokenRef.current.signal
			);
			setEvents(response?.data?.results?.sort((a, b) => {
				const dateA = new Date(a.fulldate);
				const dateB = new Date(b.fulldate);
				return dateB.getTime() - dateA.getTime();
			}) || []);
		} catch (error) {
			NotificationManager.error("", "Erro ao buscar eventos", 5000, () =>
				NotificationManager.removeAll()
			);
		}
		setIsEventsLoading(false);
	};

	const getAutomationButtons = async (condominiumId) => {
		if (!condominiumId) return;
		setIsAutomationButtonsLoading(true);
		try {
			const response =
				await AutomationButtonService.listAutomationButtonsByCondominium(
					condominiumId
				);
			setAutomationButtonsItems(response.data || []);
		} catch (error) {
			NotificationManager.error("", "Erro ao buscar automações", 5000, () =>
				NotificationManager.removeAll()
			);
		}
		setIsAutomationButtonsLoading(false);
	};

	useEffect(() => {
		if (!selectedCondominio) return;
		if (can('bravas.accessControl.automationButton.getPaginated')) {
			getAutomationButtons(selectedCondominio);
		}
	}, [selectedCondominio]);

	useEffect(() => {
		if (!selectedCondominio) return;
		getEvents(1, selectedCondominio);
	}, [selectedCondominio, eventsMode]);

	const onSseReceived = (event) => {
		if (event?.action === "createAccessEvent") {
			console.log('Receive access event: ', event);
			setEvents(prevEvents => [event.content, ...prevEvents].sort((a, b) => new Date(b.fulldate).getTime() - new Date(a.fulldate).getTime()));
		}
	}

	useEffect(() => {
		subscribe('onSseReceived', onSseReceived);
		return () => {
			unsubscribe('onSseReceived', onSseReceived);
		}
	}, [selectedCondominio])

	const handleClickInvite = () => {
		navigate("/cadastro-invitations");
	};

	const handleClickHistory = () => {
		navigate("/historico-eventos?eventType=Acesso&detail=Lado");
	};

	if (!selectedCondominio) {
		return (
			<Loader />
		);
	}

	if (!selectedCondominioObj.parent) {
		return (
			<NoLicense isRootUnit={true} />
		);
	}

	return (
		<CadastroContainer>
			<ReceptionHeader
				title={i18n.language === 'en' ? selectedCondominioObj?.name + ` ` + `${t('menu.monitoring')}` : `${t('menu.monitoring')} ` + selectedCondominioObj?.name}
				icon={<RiEye2Line size={23} />}
				selectedTab={selectedTab}
				setSelectedTab={setSelectedTab}
			/>
			{selectedTab === "portaria" && (
				<>
					<div className="reception-controls-container">
						<FastFormCondoUserProvider>
							<div className="reception-buttons-container">
								{can('bravas.accessControl.user.create') && (
									<FastFormCondoUserModal />
								)}
								{can('bravas.accessControl.command.accessComand') && (
									<OpenDoorButton />
								)}
								{can('bravas.accessControl.user.getById') && (
									<SearchCondoUser />
								)}
								{can('bravas.events.device.getByModulePaginated') && (
									<Button
										className={"button-blue reception-button"}
										label={t("monitoring.history")}
										onClick={handleClickHistory}
										icon={<ScrollText size={17} />}
									/>
								)}
								{can('bravas.accessControl.user.create') && (
									<Button
										className={"button-blue reception-button"}
										label={t("monitoring.invite")}
										action="addUser"
										onClick={handleClickInvite}
									/>
								)}
							</div>
						</FastFormCondoUserProvider>
						<div>
							<Select
								value={eventsMode}
								onChange={({ target }) => {
									setEventsMode(target.value)
								}}
								required={false}
								options={[
									{ value: 'all', text: t("monitoring.allAccesses") },
									{ value: 'main', text: t("monitoring.mainAccesses") },
									{ value: 'indoor', text: t("monitoring.internalAccesses") },
								]}
							/>
						</div>
					</div>
					<div className="reception-container-center">
						<div className="reception-container">
							<div className="access-events-container" data-expanded={((!automationButtonsItems || automationButtonsItems.length === 0) && !isEventsLoading) && (!events || events.length === 0)}>
								{isEventsLoading ? (
									<>
										<div className={`events-details-wrapper access-events-loader-container`}>
											<TitleContainer
												title={t("monitoring.lastAccess")}
												isReception={true}
											/>
											<div className="event-details-container">
												<div className="flex flex-row justify-between w-full items-center">
													<div className="flex items-center justify-center flex-col pl-10!">
														<div className="size-[120px] rounded-full shimmer"></div>
														<div className="w-[160px] h-[22px] rounded-full mt-[8px]! shimmer"></div>
													</div>
													<div className="w-[160px] flex flex-col gap-2">
														<div className="w-[150px] h-[22px] rounded-full mt-[8px]! shimmer"></div>
														<div className="w-[140px] h-[22px] rounded-full mt-[8px]! shimmer"></div>
														<div className="w-[155px] h-[22px] rounded-full mt-[8px]! shimmer"></div>
														<div className="w-[150px] h-[22px] rounded-full mt-[8px]! shimmer"></div>
													</div>
													<div className="w-[160px] flex flex-col gap-2">
														<div className="w-[150px] h-[22px] rounded-full mt-[8px]! shimmer"></div>
														<div className="w-[160px] h-[22px] rounded-full mt-[8px]! shimmer"></div>
														<div className="w-[160px] h-[22px] rounded-full mt-[8px]! shimmer"></div>
														<div className="w-[155px] h-[22px] rounded-full mt-[8px]! shimmer"></div>
													</div>
												</div>
											</div>
										</div>
										<div className="w-full h-[350px] flex flex-row gap-[9px] mt-[9px]!">
											<div className="flex flex-col h-full w-1/2">
												<h3 className="enter-title">
													<TbDoorEnter size={18} />
													{t("common.entry")}
												</h3>
												<div className="fake-way-column-container flex-[1_1] rounded-b-[8px]">
													{Array(3).fill(0).map((_, idx) => (
														<div key={idx} className="w-full h-[95px] flex items-center justify-start flex-row gap-3 px-[14px]! py-[2px]!">
															<div className="size-[62px] rounded-full shimmer"></div>
															<div className="flex flex-col gap-1">
																<div className="w-[160px] h-[22px] rounded-full shimmer"></div>
																<div className="w-[130px] h-[22px] rounded-full shimmer"></div>
															</div>
														</div>
													))}
												</div>
											</div>
											<div className="flex flex-col h-full w-1/2">
												<h3 className="exit-title">
													<TbDoorExit size={18} />
													{t("common.exit")}
												</h3>
												<div className="fake-way-column-container flex-[1_1] rounded-b-[8px]">
													{Array(2).fill(0).map((_, idx) => (
														<div key={idx} className="w-full h-[95px] flex items-center justify-start flex-row gap-3 px-[14px]! py-[2px]!">
															<div className="size-[62px] rounded-full shimmer"></div>
															<div className="flex flex-col gap-1">
																<div className="w-[160px] h-[22px] rounded-full shimmer"></div>
																<div className="w-[130px] h-[22px] rounded-full shimmer"></div>
															</div>
														</div>
													))}
												</div>
											</div>
										</div>
									</>
								) : (
									<>
										{events && events.length > 0 ? (
											<>
												<EventDetails
													isReception={true}
													title={t("monitoring.lastAccess")}
													lastAccess={events && events.length > 0 ? events[0] : {}}
												/>
												<Ways events={events?.slice(1) || []} />
											</>
										) : (
											<div className="no-events-wrapper">
												<div className="icon-wrapper">
													<IoIosCloudyNight size={70} color='white' />
												</div>
												<h2>{t('monitoring.noEventsAtMoment')}</h2>
											</div>
										)}
									</>
								)}
							</div>
							{(events && events.length > 0 || automationButtonsItems?.length > 0 || isEventsLoading) && (
								<div>
									<div
										className="reception-card-container "
										style={{
											alignItems: "center",
											display: "flex",
											flexDirection: "column",
											height: 'fit-content',
										}}
									>
										<div
											className="event-details-title-container"
											style={{
												width: "100%",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												marginBottom: "0px",
												gap: "2px"
											}}
										>
											<GoArrowSwitch
												color={"var(--textColor)"}
												size={19}
											/>
											<h1 className="event-details-title">{t("monitoring.accessFlow")}</h1>
										</div>
										<AccessEventsFlowChart listMode={eventsMode} />
									</div>
									{isAutomationButtonsLoading ? (
										<div
											className="reception-card-container"
											style={{
												alignItems: "center",
												display: "flex",
												flexDirection: "column",
												height: 'fit-content',
												flex: '1 1',
											}}
										>
											<div
												className="event-details-title-container"
												style={{
													width: "100%",
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
													marginBottom: "0px",
												}}
											>
												<h1 className="event-details-title">{t("menu.automation")}</h1>
											</div>
											<div className="automations-wrapper">
												{Array(9).fill(0).map((_, idx) => (
													<div key={idx} className="shimmer w-full min-h-full rounded-[8px]" />
												))}
											</div>
										</div>
									) : (
										<>
											{automationButtonsItems?.length > 0 ? (
												<div
													className="reception-card-container"
													style={{
														alignItems: "center",
														display: "flex",
														flexDirection: "column",
														height: 'fit-content',
														flex: '1 1',
													}}
												>
													<div
														className="event-details-title-container"
														style={{
															width: "100%",
															display: "flex",
															justifyContent: "center",
															alignItems: "center",
															marginBottom: "0px",
															position: 'sticky',
															top: 0,
															zIndex: 10,
														}}
													>
														<LuLightbulb
															color={"var(--textColor)"}
															size={19}
														/>
														<h1 className="event-details-title">{`Automações`}</h1>
													</div>
													<div className={`automations-wrapper ${automationButtonsItems.length > 9 ? 'automations-wrapper-more' : ''}`}>
														{automationButtonsItems?.map((button, idx) => (
															<AutomationButton key={idx} button={button} />
														))}
													</div>
												</div>
											) : (
												<div className="no-events-wrapper box-border! min-h-auto! flex-1!">
													<h2 className="text-lg! leading-[1.1]!">{t('monitoring.noAutomationAtMoment')}</h2>
												</div>
											)}
										</>
									)}
								</div>
							)}
						</div>
					</div>
				</>
			)
			}
			{selectedTab === "alarmes" && <AlarmMonitoring />}
			{selectedTab === "permanencia" && <PresenceMonitoring />}
			{selectedTab === "acessos" && <AccessMonitoring />}
		</CadastroContainer >
	);
};

export default Reception;